/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import { createReimburseAccount } from "../../../../redux/features/accounts/ReimburseAccount";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import CreateBank from "./CreateBank";
import CreateCategory from "./CreateCategory";
import CreateConfirm from "./CreateConfirm";
import CreateContact from "./CreateContact";
import CreatePan from "./CreatePan";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import {
  bankLookUp,
  getIFSCDetails,
  panLookUp,
  resetBankVerificationError,
  resetGSTDetails,
  resetPanLookup,
  resetPANVerification,
  verifyBankAccount,
  verifyPAN,
} from "../../../../redux/features/sharedResources/sharedResources";
import { editBeneficiary } from "../../../../redux/features/accounts/beneficiaryAccount/createAccount";

const id = (x) => x;
const CreateReimbursementAccount = () => {
  const scrollIt = useRef(null);
  const bankVerificationRequestKeyRef = useRef("");
  const bankVerificationFailedKeyRef = useRef("");
  const bankDetailsLookupRequestKeyRef = useRef("");
  const currentBankInputKeyRef = useRef("");
  const currentBankVerificationKeyRef = useRef("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state;

  const steps = [
    "PAN details",
    "Bank details",
    "User and contact details",
    "Categories, labels and recipients",
    "Confirm and create",
  ];

  const {
    panVerificationData,
    panVerificationLoading,
    panLookupData,
    panLookupLoading,
    panLookupError,
    bankLookupLoading,
    bankLookupError,
    verifyBankAccountData,
    verifyBankAccountLoading,
    verifiyBankAccountMessage,
    ifscDetailsLoading,
    ifscDetailsError: sharedIFSCDetailsError,
    ifscDetailsData,
  } = useSelector((state) => state.sharedResources);
  const ifscDetailsError =
    sharedIFSCDetailsError ||
    ifscDetailsData?.status === false ||
    Boolean(ifscDetailsData?.errors);

  const bankStatus = useSelector(
    (state) => state.sharedResources.verifyBankAccountData,
  );

  const benebankLookData = useSelector(
    (state) => state.sharedResources.bankLookupData,
  );

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  ).filter((cat) => cat?.active === "Y");

  const categoriesConfirmPage = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const isBankError = useSelector(
    (state) =>
      state.sharedResources.verifyBankAccountError ||
      state.sharedResources.verifyBankAccountData?.status === false,
  );

  const bankVerificationFailureMessage = (() => {
    const errors = verifyBankAccountData?.errors;
    const backendMessage =
      errors?.base?.[0] ||
      errors?.bank_account?.[0] ||
      errors?.ifsc_code?.[0] ||
      errors?.message ||
      (typeof errors === "string" ? errors : null) ||
      verifyBankAccountData?.error ||
      verifyBankAccountData?.message;

    if (verifyBankAccountData?.status === false) return backendMessage;
    if (isBankError && !verifyBankAccountData) {
      return typeof verifiyBankAccountMessage === "string"
        ? verifiyBankAccountMessage
        : verifiyBankAccountMessage?.errors?.base?.[0] ||
            verifiyBankAccountMessage?.errors?.bank_account?.[0];
    }
    return null;
  })();
  const isIFSCNotFoundVerificationError =
    typeof bankVerificationFailureMessage === "string" &&
    bankVerificationFailureMessage.trim().toLowerCase() ===
      "not found ifsc code";
  const reimbursementIFSCError =
    ifscDetailsError || isIFSCNotFoundVerificationError;
  const canMarkAsVirtualAccount =
    bankVerificationFailureMessage === "Invalid Bank Account Number / IFSC";

  const { reimbursementAccountCreateError } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const [virtualAccount, setVirtualAccount] = useState(false);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [lookupNext, setLookupNext] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [isButtonDisabled] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [contactBol, setContactBol] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [bankUserInfo, setBankUserInfo] = useState([]);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [payload, setPayload] = useState({
    bank_account: userData?.bank_acc_no || "",
    ifsc_code: userData?.ifsc_code || "",
    contact_no: userData?.contact_no || "",
    email_id: userData?.email_id || "",
    gstin: userData?.gstin_no || "",
    name: "",
    categories: userData?.category || "",
    panNumber: userData?.pan || "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    linked_user_id: "",
    userName: "",
    userId: "",
    virtual: "",
  });

  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [exitFlow, setExitFlow] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [createDisabled, setCreateDisabled] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [createRecipient, setCreateRecipient] = useState([]);
  const [remPan, setRemPan] = useState();
  const [newData, setNewData] = useState({
    gstin: "",
  });

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const bene_acc_id = userData?.id;

  const dataReceiveFromContact = (data) => {
    setContactBol(data);
  };

  const handleCreateAccount = async () => {
    if (createDisabled) return;
    setCreateDisabled(true);
    try {
      let updatedPayload = { ...payload, navigate };
      if (
        selectedFields.length === categoriesConfirmPage.length ||
        selectedFields.length === GlobalConfiguration?.lengthCheckZero
      ) {
        updatedPayload.category_ids = null;
      } else {
        updatedPayload = {
          ...updatedPayload,
          category_ids: selectedFields,
        };
      }

      let data;
      if (userData?.type === "switch_account") {
        data = await dispatch(
          editBeneficiary({
            ...updatedPayload,
            name: updatedPayload?.account_name ?? "",
            id: bene_acc_id,
            email: updatedPayload?.email_id,
            type_of_account: "reimbursement",
          }),
        ).unwrap();
      } else {
        data = await dispatch(createReimburseAccount(updatedPayload)).unwrap();
      }

      const accountId = data.reimbursement_accounts[0].id;

      if (data?.status === true) {
        navigate(
          `/reimbursement_account_dashboard/create_reimbursement_account/success/${accountId}`,

          {
            state: { type: userData?.type },
          },
        );
      }
    } catch (error) {
      navigate(
        "/reimbursement_account_dashboard/create_reimbursement_account/error",
        {
          replace: true,
          state:
            error?.response?.data?.error ||
            error?.response?.data?.errors ||
            reimbursementAccountCreateError?.data?.errors,
        },
      );
      return error;
    } finally {
      setCreateDisabled(false);
    }
  };

  const handleMainCreate = () => {
    handleCreateAccount();
  };
  useEffect(() => {
    setRemPan(payload.panNumber);
  }, [payload.panNumber]);

  useEffect(() => {
    if (!panVerificationLoading) {
      if (panVerificationData?.status === true) {
        setVerifiedPan(true);
        dispatch(panLookUp({ pan_number: payload.panNumber }));
        setPayload({
          ...payload,
          legalName: panVerificationData?.pan_details?.full_name,
          account_name: panVerificationData?.pan_details?.full_name,
        });
      } else if (
        panVerificationData?.status === false &&
        payload?.panNumber.length === GlobalConfiguration.panLength
      ) {
        setVerifiedPan(false);
      }
    }
  }, [panVerificationData]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    Validation.ifscRegex.test(payload?.ifsc_code);

  const bankInputKey =
    payload?.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
    isIFSCValid
      ? `${payload.bank_account}:${payload.ifsc_code}`
      : "";
  const bankVerificationKey = bankInputKey
    ? `${bankInputKey}:${payload.legalName || ""}`
    : "";
  currentBankInputKeyRef.current = bankInputKey;
  currentBankVerificationKeyRef.current = bankVerificationKey;

  const requestBankDetails = (
    bankAccount,
    ifsc,
    shouldFetchIFSCDetails = true,
  ) => {
    const requestKey = `${bankAccount}:${ifsc}`;
    if (bankDetailsLookupRequestKeyRef.current === requestKey) return;

    bankDetailsLookupRequestKeyRef.current = requestKey;
    const lookupRequest = dispatch(
      bankLookUp({
        ifsc,
        bank_account_no: bankAccount,
      }),
    );
    const requests = [lookupRequest];
    if (shouldFetchIFSCDetails) {
      requests.push(
        dispatch(
          getIFSCDetails({
            search_string: ifsc,
            page_no: GlobalConfiguration?.lengthCheckOne,
            page_size: GlobalConfiguration?.filterResults,
          }),
        ),
      );
    }

    Promise.all(requests).then((results) => {
      const ifscResult = shouldFetchIFSCDetails ? results[1] : null;
      if (ifscResult) {
        const ifscPayload = ifscResult.payload;
        const ifscRequestFailed =
          ifscResult.meta?.requestStatus === "rejected" ||
          ifscPayload?.status === false ||
          Boolean(ifscPayload?.errors) ||
          !ifscPayload?.ifsc_details?.[0];
        const ifscBackendError =
          ifscPayload?.errors?.base?.[0] ||
          ifscPayload?.errors?.ifsc_code?.[0] ||
          ifscPayload?.errors?.message ||
          (typeof ifscPayload?.errors === "string"
            ? ifscPayload.errors
            : null) ||
          ifscPayload?.error ||
          ifscPayload?.message;

        if (
          ifscRequestFailed &&
          currentBankInputKeyRef.current === requestKey &&
          ifscBackendError &&
          !(
            ifscResult.meta?.requestStatus === "fulfilled" &&
            ifscPayload?.errors?.base?.[0]
          )
        ) {
          CommonToast({
            text: ifscBackendError,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }

        if (
          manualVirtualAccount &&
          ifscRequestFailed &&
          currentBankInputKeyRef.current === requestKey
        ) {
          setManualVirtualAccount(false);
          setPayload((prev) => ({ ...prev, virtual: false }));
        }
      }

      if (
        results.some(
          (result) =>
            result.meta?.requestStatus === "rejected" ||
            result.payload?.status === false ||
            Boolean(result.payload?.errors),
        ) &&
        bankDetailsLookupRequestKeyRef.current === requestKey
      ) {
        bankDetailsLookupRequestKeyRef.current = "";
      }
    });
  };

  useEffect(() => {
    if (payload.ifsc_code?.length < GlobalConfiguration.ifscLength) {
      dispatch(resetBankVerificationError());
    }
    if (
      payload.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (
      payload.bank_account?.length === GlobalConfiguration.lengthCheckZero &&
      payload.ifsc_code?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      BenEnableNextButton(true);
      dispatch(resetBankVerificationError());
    }
    if (bankInputKey) {
      if (bankVerificationRequestKeyRef.current !== bankVerificationKey) {
        bankVerificationRequestKeyRef.current = bankVerificationKey;
        bankVerificationFailedKeyRef.current = "";
        dispatch(
          verifyBankAccount({
            ifsc_code: payload.ifsc_code,
            bank_account: payload.bank_account,
            legal_name: payload.legalName,
            navigate,
          }),
        ).then((result) => {
          if (currentBankVerificationKeyRef.current !== bankVerificationKey) {
            return;
          }

          if (
            result.meta?.requestStatus === "fulfilled" &&
            result.payload?.status === true &&
            currentBankInputKeyRef.current === bankInputKey
          ) {
            const verificationDetails =
              result.payload?.verification_details?.[0] || {};
            const hasCompleteAddressDetails = [
              "branch",
              "city",
              "district",
              "address",
            ].every((field) => Boolean(verificationDetails[field]));

            requestBankDetails(
              payload.bank_account,
              payload.ifsc_code,
              !hasCompleteAddressDetails,
            );
          } else if (
            result.meta?.requestStatus === "rejected" ||
            result.payload?.status === false
          ) {
            bankVerificationFailedKeyRef.current = bankVerificationKey;
          }
        });
      }
    } else {
      bankVerificationRequestKeyRef.current = "";
      bankVerificationFailedKeyRef.current = "";
      bankDetailsLookupRequestKeyRef.current = "";
    }
  }, [
    payload.ifsc_code,
    payload.bank_account,
    payload.legalName,
    bankInputKey,
  ]);

  useEffect(() => {
    if (
      bankInputKey &&
      isBankError === true &&
      manualVirtualAccount &&
      bankVerificationFailedKeyRef.current === bankVerificationKey
    ) {
      dispatch(
        getIFSCDetails({
          search_string: payload.ifsc_code,
          page_no: GlobalConfiguration?.lengthCheckOne,
          page_size: GlobalConfiguration?.filterResults,
        }),
      );
    }
  }, [
    dispatch,
    bankInputKey,
    bankVerificationKey,
    isBankError,
    manualVirtualAccount,
    payload.bank_account,
    payload.ifsc_code,
  ]);

  useEffect(() => {
    if (
      createRecipient &&
      createRecipient.length > GlobalConfiguration.lengthCheckZero
    ) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [createRecipient]);

  useEffect(() => {
    if (benebankLookData?.status && activeStep === 1) {
      BenEnableNextButton(true);
    }
  }, [benebankLookData]);

  useEffect(() => {
    if (
      location?.state?.bank_acc_no &&
      location?.state?.ifsc_code &&
      location?.state?.type === "switch_account"
    ) {
      BenEnableNextButton(true);
      setBankLookupNext(true);
      return;
    }

    if (!bankLookupLoading) {
      setTimeout(() => {
        if (isIFSCValid && !isBankError) {
          if (benebankLookData?.status) {
            setBankLookupNext(false);
          } else if (
            !verifyBankAccountLoading &&
            verifyBankAccountData?.status
          ) {
            setBankLookupNext(true);
          }
        }
      }, 0);
    }
  }, [
    bankLookupLoading,
    benebankLookData,
    isBankError,
    isIFSCValid,
    virtualAccount,
    verifyBankAccountLoading,
    verifyBankAccountData,
  ]);

  useEffect(() => {
    setSelectedValue("legalname");
  }, [payload.panNumber]);
  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <CreatePan
            verifiedPan={verifiedPan}
            panNumber={payload.panNumber}
            handlePanChange={handlePanChange}
            panDetails={panVerificationData?.pan_details}
            beneLookData={panLookupData}
            panLookupLoading={panLookupLoading}
            beneLookLoading={panLookupLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={panVerificationLoading}
            setIsArchived={id}
            setIsApproved={id}
            setIsDennied={id}
            setIsPending={id}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            beneLookError={panLookupError}
            setPayload={setPayload}
            payload={payload}
            GSTStatus={GSTStatus}
            setGSTStatus={setGSTStatus}
            setNewData={setNewData}
            type={userData?.type}
          />
        );
      case 1:
        return (
          <CreateBank
            isButtonDisabled={isButtonDisabled}
            setBankIsArchived={id}
            setBankIsApproved={id}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={id}
            setBankIsDennied={id}
            nextButtonEnabled={nextButtonEnabled}
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            payload={payload}
            setPayload={setPayload}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            setBankUserInfo={setBankUserInfo}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            isBankError={isBankError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            ownerAccIfscData={ifscDetailsData}
            ownerAccIfscError={reimbursementIFSCError}
            canMarkAsVirtualAccount={canMarkAsVirtualAccount}
            type={userData?.type}
          />
        );
      case 2:
        return (
          <CreateContact
            payload={payload}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectedCatFields={selectedCatFields}
          />
        );
      case 3:
        return (
          <CreateCategory
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            parentCreateBen={dataReceiveFromContact}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            recipients={recipients}
            setRecipients={setRecipients}
            type={userData?.type}
          />
        );
      case 4:
        return (
          <CreateConfirm
            payload={payload}
            selectedFields={selectedFields}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            remPan={remPan}
            setRemPan={setRemPan}
            manualVirtualAccount={manualVirtualAccount}
            type={userData?.type}
            bene_acc_id={bene_acc_id}
            virtualAccount={virtualAccount}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("RUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
      }
    }
  }, [services, isLoading]);
  const isPanVerified = verifiedPan === true;

  const hasAssociatedAccounts = panLookupData?.status === true;

  const noAssociatedAccounts = panLookupError === true;

  const isGstEmpty =
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero;

  const isGstVerified =
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus === true;

  const isGstInvalid =
    payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
    !isGstVerified;

  const shouldEnableNextButtonFirstStepper =
    isPanVerified &&
    ((noAssociatedAccounts && (isGstEmpty || isGstVerified)) ||
      (hasAssociatedAccounts && lookupNext)) &&
    !isGstInvalid;

  const isBankStatusValid = bankStatus?.status === true;
  const isBankAccountValid =
    payload?.bank_account?.length > GlobalConfiguration.lengthCheckZero;
  const isIfscCodeValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength;
  const isVerifyBankValid = verifyBankAccountData?.status === true;
  const hasValidIFSCDetails =
    reimbursementIFSCError === false &&
    ifscDetailsData?.status !== false &&
    Boolean(ifscDetailsData?.ifsc_details?.[0]);
  const canContinueVirtualAccount =
    manualVirtualAccount &&
    hasValidIFSCDetails &&
    !verifyBankAccountLoading &&
    !ifscDetailsLoading;

  const shouldEnableNextButtonSecondStepper =
    benebankLookData === null
      ? isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid
      : isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid &&
        bankLookupNext === true;

  const isContactValid = contactBol.contact === true;
  const isEmailValid = contactBol.email === true;
  const isAccountNameValid = contactBol.accountname === true;

  const shouldEnableNextButtonThirdStepper =
    isContactValid && isEmailValid && isAccountNameValid;

  useEffect(() => {
    if (
      activeStep === GlobalConfiguration.lengthCheckZero &&
      !bankLookupLoading
    ) {
      BenEnableNextButton(!shouldEnableNextButtonFirstStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      BenEnableNextButton(
        !(shouldEnableNextButtonSecondStepper && bankLookupNext),
      );
    } else if (activeStep === GlobalConfiguration.lengthCheckTwo) {
      BenEnableNextButton(!shouldEnableNextButtonThirdStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      BenEnableNextButton(!true);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      // setRemPan(payload.panNumber);
      BenEnableNextButton(false);
    }
  }, [
    activeStep,
    bankStatus?.status,
    contactBol?.contact,
    contactBol?.email,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBankAccountData?.status,
    bankLookupNext,
    panLookupData,
    lookupNext,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    bankLookupLoading,
    bankLookupError,
    selectedFields,
    categories,
    showAlertCategories,
    manualVirtualAccount,
  ]);

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
      // if (event.key === "Tab") {
      //   event.preventDefault();
      // }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      // event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleNext = () => {
    if (
      activeStep === GlobalConfiguration.lengthCheckThree &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      if (userData?.type === "switch_account") {
        setShowAlertCategories(false);
      } else {
        setShowAlertCategories(true);
      }
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      handleMainCreate();
    } else {
      // setButtonDisabled(true);
      setShowAlertCategories(false);
      setActiveStep(
        (prevActiveStep) => prevActiveStep + GlobalConfiguration.lengthCheckOne,
      );
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, GlobalConfiguration.delayTime);
    }
  };

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      if (payload?.panNumber?.length === GlobalConfiguration?.lengthCheckZero) {
        navigate(GlobalConfiguration?.navigate_back);
        return;
      } else {
        setExitFlow(true);
        return;
      }
    }
    // setButtonDisabled(true);
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, GlobalConfiguration.delayTime);
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const handlePanChange = (e) => {
    const inputPan = e.target.value.toUpperCase();

    if (!Validation.alphanumericRegex.test(inputPan)) {
      return;
    }

    if (inputPan.length > 10) {
      return;
    }
    if (
      !Validation.panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetPanLookup());
    } else if (inputPan.length === GlobalConfiguration.panLength) {
      dispatch(verifyPAN({ pan_number: inputPan, showToast: false }));
      setGSTStatus(null);
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
    }
    setPayload({
      ...payload,
      panNumber: inputPan,
      gstin: userData?.gstin || "",
    });
    setDisableCreateNext(false);
    setLookupNext(false);
    dispatch(resetGSTDetails());
  };

  const accountHome = () => {
    navigate(GlobalConfiguration?.navigate_back);
  };

  useEffect(() => {
    if (newData.gstin?.length !== GlobalConfiguration?.gstLength) {
      setLookupNext(false);
    }
  }, [payload.gstin]);

  useEffect(() => {
    scrollIt.current.scrollTop = GlobalConfiguration?.lengthCheckZero;
  }, [activeStep]);

  useEffect(() => {
    if (location?.state?.pan && location?.state?.type === "switch_account") {
      handlePanChange({ target: { value: location.state.pan } });
      setDisableCreateNext(true);
      setLookupNext(true);
    }
  }, [location?.state?.type]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: manualVirtualAccount
        ? canContinueVirtualAccount
        : !nextButtonEnabled &&
          !verifyBankAccountLoading &&
          !ifscDetailsLoading &&
          !bankLookupLoading,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[2],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[3],
    },
    {
      previousText: "Previous",
      nextText: "Confirm",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !createDisabled,
      stepperText: steps[4],
    },
  ];

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter") return;

      e.preventDefault();
      e.stopPropagation();

      if (
        activeStep === GlobalConfiguration?.lengthCheckZero &&
        shouldEnableNextButtonFirstStepper
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckOne &&
        shouldEnableNextButtonSecondStepper
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration?.lengthCheckTwo &&
        shouldEnableNextButtonThirdStepper
      ) {
        handleNext();
        return;
      } else if (activeStep === GlobalConfiguration?.lengthCheckThree) {
        if (selectedFields?.length === categories?.length) {
          setShowAlertCategories(true);
        } else {
          handleNext();
          return;
        }
      }

      if (activeStep === GlobalConfiguration?.lengthCheckFour) {
        handleMainCreate();
      }
    },
    [activeStep, handleNext],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  return (
    <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
      <div className="w-width-full">
        <div className="h-navbar-height hidden Qsmd:block"></div>
        <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] my-margin-sm Qsmd:my-margin-base"></div>
      </div>
      {exitFlow && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            subtext="Leaving this page will not update the changes made."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setExitFlow(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() =>
              navigate(GlobalConfiguration?.navigate_back)
            }
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={"Unsafe to proceed"}
            bulletPoints={[
              "All categories will be linked to a single account.",
              "It is recommended to distribute categories across appropriate accounts.",
            ]}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            // btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div className="bene_crt_reminder_header flex justify-center items-end !bottom-bottom-base Qsmd:min-h-stepper-height rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      <div className="flex items-center w-width-full bg-primary-nav p-padding-sm fixed left-left-base top-top-base z-z-index-header Qsmd:hidden">
        <div
          className="w-icon-sm h-icon-sm cursor-pointer"
          onClick={accountHome}
        >
          <SVGComponent
            url={ICONS.ARROW_LEFT_WHITE}
            color="var(--text-primary)"
          />
        </div>

        <div className=" flex flex-col pl-padding-md">
          <p className=" text-font-md font-sans text-text-primary">
            {" "}
            Reimbursement Account
          </p>
          {activeStep === 0 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              PAN details
            </p>
          )}
          {activeStep === 1 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Bank details
            </p>
          )}
          {activeStep === 2 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              User and contact details
            </p>
          )}
          {activeStep === 3 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Categories, labels and recipients
            </p>
          )}
          {activeStep === 4 && (
            <p className="text-font-xs font-sans text-text-primary">
              {" "}
              Confirm and create account
            </p>
          )}
        </div>
      </div>

      <>
        <div className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full">
          <div className="h-stepper-moble-height w-width-full hidden flex-shrink-0"></div>
          <div
            ref={scrollIt}
            className={`w-width-full h-full overflow-x-hidden Qsmd:pt-padding-lg Qsmd:pb-padding-md pt-padding-base no-scrollbar ${
              activeStep === GlobalConfiguration.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClass
            }`}
          >
            {renderCreateAccount()}
          </div>
        </div>
      </>

      <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
    </div>
  );
};

export default CreateReimbursementAccount;
